import { Component } from '@angular/core';

@Component({
  selector: 'app-no-instance',
  templateUrl: './no-instance.component.html',
  styleUrl: './no-instance.component.css'
})
export class NoInstanceComponent {

}
